import { Button } from "@/components/ui/button";
import { ArrowRightIcon } from "@phosphor-icons/react";

const steps = [
  {
    n: "01",
    title: "Request early access",
    body: "Tell us about your firm and your next submission cycle. No confidential details required.",
  },
  {
    n: "02",
    title: "Receive your early access invite",
    body: "We are opening access gradually to keep the product focused, secure and useful for early firms.",
  },
  {
    n: "03",
    title: "Prepare your submission with Ranq",
    body: "Use Ranq to structure, draft and strengthen your Chambers and Legal 500 submissions.",
  },
  {
    n: "04",
    title: "Review before filing",
    body: "Your team reviews and finalises the editable Word output before submitting to the directory.",
  },
];

export default function Process() {
  const scrollToForm = () => {
    const el = document.getElementById("early-access");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-32 bg-[#f3efe6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <p className="text-sm uppercase tracking-[0.18em] font-semibold text-stone-500">
              Early access
            </p>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl tracking-tight font-medium text-stone-900">
              How early access works.
            </h2>
          </div>
          <Button
            data-testid="process-cta"
            onClick={scrollToForm}
            className="self-start md:self-auto h-12 px-7 rounded-full bg-stone-900 hover:bg-stone-800 text-[#f7f4ec]"
          >
            Request early access
            <ArrowRightIcon size={16} weight="bold" className="ml-2" />
          </Button>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, idx) => (
            <div
              key={s.n}
              data-testid={`process-step-${idx}`}
              className="relative overflow-hidden rounded-2xl border border-stone-200 bg-[#f7f4ec] p-7 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md hover:border-stone-300"
            >
              <span
                aria-hidden="true"
                className="ranq-step-num absolute -top-2 -right-1 text-[110px] leading-none select-none"
              >
                {s.n}
              </span>
              <div className="relative">
                <p className="text-xs uppercase tracking-[0.18em] font-semibold text-stone-500">
                  Step {s.n}
                </p>
                <h3 className="mt-3 font-heading text-lg md:text-xl font-medium text-stone-900">
                  {s.title}
                </h3>
                <p className="mt-3 text-stone-600 leading-relaxed">{s.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
